import { createContext, useCallback, useMemo, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { node } from 'prop-types'

const Context = createContext({})

export const DialogProvider = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [Footer, setFooter] = useState(() => '')
  const [Header, setHeader] = useState(() => '')
  const [Body, setBody] = useState(() => '')
  const displayModal = useCallback(
    ({ header: h, body: b, footer: f }) => {
      setHeader(() => h)
      setBody(() => b)
      setFooter(() => f)
      setOpen(true)
    },
    [setFooter, setBody, setHeader, setOpen],
  )

  const value = useMemo(
    () => ({
      displayModal,
    }),
    [displayModal],
  )

  return (
    <Context.Provider value={value}>
      {children}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false)
        }}
      >
        <DialogTitle>
          <Header close={() => setOpen(false)} />
        </DialogTitle>
        <DialogContent>
          <Body close={() => setOpen(false)} />
        </DialogContent>
        <DialogActions>
          <Footer close={() => setOpen(false)} />
        </DialogActions>
      </Dialog>
    </Context.Provider>
  )
}

DialogProvider.propTypes = {
  children: node.isRequired,
}
